$ = require 'jquery'
{ ActionHistory } = require '@trello/action-history'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
ReactDOM = require '@trello/react-dom-wrapper'
React = require 'react'

ApiError = require 'app/scripts/network/api-error'
Auth = require 'app/scripts/db/auth'
Card = require 'app/scripts/models/card'
containsValidUrl = require 'app/scripts/lib/util/url/contains-valid-url'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
{ getSuggestionsFeedback } = require 'app/scripts/views/feedback/collectors/get-suggestions-feedback'
inviteAddNameTemplate = require 'app/scripts/views/templates/invite_add_name'
{ getKey, Key } = require '@trello/keybindings'
l = require 'app/scripts/lib/localize'
localizeServerError = require 'app/scripts/lib/localize-server-error'
{ maybeDisplayMemberLimitsError } = require 'app/scripts/views/board-menu/member-limits-error'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
SelectMemberOnCardView = require 'app/scripts/views/member/select-member-on-card-view'
{ Storage } = require '@trello/storage'
AutoCompleteMultiBoardGuestAlert = require 'app/scripts/views/organization/invite-member-autocomplete-multi-board-guest-alert'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
template = require 'app/scripts/views/templates/popover_select_members'
{ track, trackUe, trackDebounced } = require '@trello/analytics'
searchFilter = require 'app/scripts/lib/util/text/search-filter'
isDesktop = require('@trello/browser').isDesktop()

MAX_EXPANDED_MEMBERS = 9
MAX_SUGGESTIONS = 5

# NOTE: This class is meant to work with the model being a Card or a
# CardComposer(!)
module.exports = class CardMemberSelectView extends View
  viewTitleKey: 'members'

  initialize: ->
    @showAllOrgMembers = false
    @wouldBecomeBillableGuestPromise = null

    @updateSearch = _.debounce(@updateSearch, 100)

    @makeDebouncedMethods 'renderMems', 'renderSuggested'

    # If the @model is a Card Composer, there won't be a memberList we have to
    # watch
    if @model.memberList?
      @listenTo @model.memberList, 'add remove reset', =>
        @updateOrdering()
        @renderMemsDebounced()
        @renderSuggestedDebounced()

    @updateOrdering()

  remove: ->
    if @reactRoot
      ReactDOM.unmountComponentAtNode(@reactRoot)
    super

  events:
    'click .js-board-members .js-select-member': 'selectMem'
    'click .js-org-members .js-select-member': 'selectMem'
    'click .js-suggestions .js-select-member': 'addSuggestedMember'
    'click .js-show-org-members': 'showOrgMembers'
    'click .js-suggested-actions-feedback': getSuggestionsFeedback({ placement: 'Members Select' })
    'mouseenter .pop-over-member-list .item': 'hoverMemberSelect'
    'input .js-search-mem': (e) ->
      @updateSearch()
      @renderSuggested()

    'keydown': 'keydownEvent'

    # send email invite to new email address
    'click .js-send-email-invite': 'sendEmailInvite'
    'submit .js-email-data': 'sendEmailInvite'

  updateOrdering: ->
    @_onCardMembers = {}
    @_onListMembers = {}
    @_onBoardMembers = {}

    addCardMembers = (target, card) ->
      card.memberList.forEach (member) ->
        target[member.id] = true

    # Might be the card composer
    if @model instanceof Card
      addCardMembers(@_onCardMembers, @model)
    @model.getList().cardList.forEach(addCardMembers.bind(null, @_onListMembers))
    @model.getBoard().listList.forEach (list) =>
      list.cardList.forEach(addCardMembers.bind(null, @_onBoardMembers))


  render: ->
    board = @model.getBoard()

    org = board.getOrganization()
    onlyOrgMembers = org?.onlyOrgMembers()
    onlyManagedMembers = org?.onlyManagedMembers()
    onlyOrgOrManagedMembers = org?.onlyOrgOrManagedMembers()

    @$el.html(template({
      canInviteMembers: !onlyOrgMembers && !onlyManagedMembers && !onlyOrgOrManagedMembers && board.canInviteMembers()
      includeOrgMembers: (board.getOrganization()? && board.canInviteMembers()) || @model.getBoard().isEditableByTeamMemberAndIsNotABoardMember()
      placeholder: l('add member placeholder')
    }))

    @renderMems()
    @renderSuggested()

  getSearch: ->
    @$('.js-search-mem').val().trim()

  filteredMembers: (members, search) ->
    satisfiesSearch = searchFilter(search)

    _.chain(members)
      .filter (mem) =>
        satisfiesSearch(Util.getMemNameArray(mem))
      .first(8)
      .value()

  filteredBoardMembers: (term) ->
    board = @model.getBoard()
    list = @model.getList()

    activeMembers = @activeBoardMembers()

    sortedMembers = activeMembers.sortBy (member) =>
      prefix =
        if Auth.isMe(member)
          0
        else if @_onCardMembers[member.id]
          1
        else if @_onListMembers[member.id]
          2
        else if @_onBoardMembers[member.id]
          3
        else
          4

      return prefix + member.get('fullName')

    if term
      @filteredMembers(sortedMembers, term)
    else
      sortedMembers

  filteredOrgMembers: (term) ->
    if @showOrgSection()
      org = @model.getBoard().getOrganization()
      if org?.isPO() && org?.isBusinessClass()
        @orgMembersPromise ?= ModelLoader.loadOrganizationMembersDataWithAvailableLicenseCount(org.id)
      else
        @orgMembersPromise ?= ModelLoader.loadOrganizationMembersData(org.id)

      @orgMembersPromise.then (members) =>
        nonBoardMembers = org.memberList.filterDeactivated(force: true)
          .without(@model.getBoard().memberList.models...)

        if term
          @filteredMembers(nonBoardMembers, term)
        else
          nonBoardMembers
    else
      []

  hasSearch: ->
    @getSearch() != ''

  showOrgSection: ->
    # Only include team members if they've started searching or clicked on the
    # "Show team members" button … we want to keep the UI simple for the
    # common case
    org = @model.getBoard().getOrganization()
    org? && (@showAllOrgMembers || @hasSearch())

  renderMems: ->
    term = @getSearch()
    boardMemList = @filteredBoardMembers(term)
    orgMemList = @filteredOrgMembers(term)

    sections =
      '.js-board-members': boardMemList
      '.js-org-members': orgMemList

    showOrgSection = @showOrgSection()
    @$('.js-show-org-members').toggleClass('hide', showOrgSection)
    @$('.js-invite-results').toggleClass('hide', !Util.checkEmail(term))

    @_renderMemsPromise?.cancel()
    @_renderMemsPromise = Promise.each _.keys(sections), (selector) =>
      $section = @$(selector)
      if $section.length == 0
        return

      $loading = $section.find('.js-loading')
      $noResults = $section.find('.js-no-results')

      $loading.removeClass('hide')
      $noResults.addClass('hide')

      Promise.resolve(sections[selector])
      .then (memList) =>
        $loading.addClass('hide')

        $memList = $section.find('.js-mem-list')
        $memList.toggleClass('collapsed', memList.length > MAX_EXPANDED_MEMBERS)
        $noResults.toggleClass('hide', memList.length > 0)

        if memList.length > 0
          @$('.js-board-members').removeClass('hide')
          @$('.js-invite-no-results').addClass('hide')
          @$('.js-org-members').toggleClass('hide', !showOrgSection)

        subviews = for mem in memList
          @subview(SelectMemberOnCardView, mem, { showUnconfirmed: true, card: @model })

        @ensureSubviews(subviews, $memList)
    .cancellable()
    .then =>
      if @hasSearch()
        $elem = @$el.find('.item').first()
        if $elem.length > 0
          Util.selectMenuItem(@$el, '.item', $elem)
        else
          @renderEmailInviteToSearchResults({ email: term })

    .done()
    @

  activeBoardMembers: ->
    @model.getBoard().memberList.filterDeactivated(force: true)

  renderSuggested: ->
    $suggestions = @$('.js-suggestions')

    me = Auth.me()
    suggestedMembers = @getSuggestedMembers()

    showSuggestions =
      !@hasSearch() &&
      suggestedMembers.length > 0 &&
      # Don't bother showing suggestions if we can already see
      # all of the members and their full names
      @activeBoardMembers().length > MAX_EXPANDED_MEMBERS

    $suggestions.toggleClass('hide', !showSuggestions)
    $memberList = $suggestions.find('.js-mem-list')

    if showSuggestions
      subviews = suggestedMembers.map (member) =>
        @subview(SelectMemberOnCardView, member, { card: @model }, "join-suggestion-#{ member.id }")

      @ensureSubviews(subviews, $memberList)
      trackDebounced.hour("Suggestions", "Card Members Menu", "Displayed", suggestedMembers.length)
    else
      $memberList.empty()

    @

  getSuggestedMembers: ->
    history = ActionHistory.get()

    board = @model.getBoard()
    idList = @model.get('idList')

    suggested = new Set()

    joinEntry = { action: { type: 'join', idMember: Auth.myId() } }
    addMemberEntries =
      history.filter ({ action, context }) ->
        action.type == 'add-member' &&
        context.idList == idList
      .filter ({ action }) ->
        if suggested.has(action.idMember)
          false
        else
          suggested.add(action.idMember)
          true

    [joinEntry, addMemberEntries...]
    .filter ({ action }) => @model.isValidSuggestion(action, true)
    .map ({ action }) =>
      @modelCache.get('Member', action.idMember)
    .slice(0, MAX_SUGGESTIONS)
    .sort (a, b) ->
      if Auth.isMe(a) then -1
      else if Auth.isMe(b) then 1
      else
        aFullName = a.get('fullName').toLowerCase()
        bFullName = b.get('fullName').toLowerCase()
        aFullName.localeCompare(bFullName)

  hoverMemberSelect: (e) ->
    Util.selectMenuItem(@$el, '.item', e.currentTarget)

  keydownEvent: (e) ->
    key = getKey(e)

    if key in [Key.Tab, Key.Enter]
      Util.stop(e)
      @$('.js-mem-list .item.selected:first .js-select-member').first().click()
      @$('.js-search-mem').val('')
      @focusSearch()
      @renderMems()
    else if key in [Key.ArrowUp, Key.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$el, '.item', key)

    return

  updateSearch: (e) ->
    @$('.js-invite-error').addClass('hide')
    @renderMems()
    @focusSearch()

  selectMem: (e) ->
    Util.stop(e)
    model = @model

    $mem = $(e.currentTarget)
    $item = $mem.closest('.item')
    idMem = $mem.attr('idMember')

    if $item.hasClass('active')
      model.removeMember(idMem)
      $item.removeClass('active')
      track("Card", "Change Member", "Remove Member")
    else
      board = @model.getBoard()
      member = ModelCache.get('Member', idMem)
      Promise.try ->
        if !board.hasActiveMembership(member)
          Promise.fromNode (next) ->
            if Auth.isMe(member) && model.getBoard().isEditableByTeamMemberAndIsNotABoardMember()
              Alerts.show('woohoo-you-are-now-a-member-of-this-board', 'info', 'join-board', 4000)
            board.addMember(member, next)
            track("Card", "Add Member to Board and Card")
      .then =>
        model.addMember(idMem)
        $item.addClass('active')
        track("Card", "Change Member", "Add Member")

        # Tracking for adding invitees to cards
        boardMembers = @model.getBoard().memberList.models
        myId = Auth.me().id
        boardMembers.forEach((boardMember) ->
          if boardMember.get('id') == idMem && \
             boardMember.get('idMemberReferrer') == myId
            trackUe(
              'card',
              'adds',
              'invitee',
              'to card',
              '',
              '',
              { member: myId, addedMember: idMem }
            )
        )
      .done()

    @focusSearch()

    return

  addSuggestedMember: (e) ->
    Util.stop(e)

    idMember = @$(e.currentTarget).attr('idMember')

    @model.addMember(idMember)

    track("Card", "Suggested", if Auth.isMe(idMember) then "Join" else "Add Member")

    @focusSearch()

    return

  focusSearch: ->
    @$('.js-search-mem').focus()
    return

  showOrgMembers: (e) ->
    @showAllOrgMembers = true
    @renderMems()
    return

  wouldBecomeBillableGuest: (email) =>
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ApiPromise = require 'app/scripts/network/api-promise'
    board = @model.getBoard()

    if !board.hasOrganization()
      return Promise.resolve false

    org = board.getOrganization()
    if org && !org.isFeatureEnabled('multiBoardGuests')
      return Promise.resolve false

    ApiPromise
      url: '/1/search/members/'
      type: 'get'
      data:
        idBoard: board?.id
        query: email
      dataType: 'json'
    .then (data) =>
      data.length == 1 and data[0].wouldBecomeBillableGuest

  renderEmailInviteToSearchResults: (data) ->
    @$('.js-invite-no-results').removeClass('hide')
    puncSpacePattern = /[\s\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/
    puncPattern = /[\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/

    fullName = _.compact(Util.removeDomainFromEmailAddress(data.email).split(puncSpacePattern)).join(" ").replace(puncPattern, "")
    board = @model.getBoard()
    org = board?.getOrganization()

    _.extend data,
      fullName: Util.toTitleCase(fullName)
      canAddAsObserver: org?.isFeatureEnabled('observers')
      modelType: 'Board'
      isLoading: true
      isOrgAdmin: org?.owned()
      isDesktop: isDesktop

    onlyOrgMembers = org?.onlyOrgMembers()
    onlyManagedMembers = org?.onlyManagedMembers()
    onlyOrgOrManagedMembers = org?.onlyOrgOrManagedMembers()
    isEmailSearch = Util.checkEmail(data.email)
    canInvite = !onlyOrgMembers && !onlyManagedMembers && !onlyOrgOrManagedMembers && isEmailSearch && board?.canInviteMembers()

    @$('.js-board-members').addClass('hide')
    @$('.js-org-members').addClass('hide')

    if canInvite
      @$('.js-invite-no-results').addClass('hide')
      @$('.js-invite-results').html inviteAddNameTemplate(data)
        .removeClass('hide')

      @wouldBecomeBillableGuestPromise?.cancel()
      @wouldBecomeBillableGuestPromise = @wouldBecomeBillableGuest(data.email)
      .cancellable()
      .then (wouldBecomeBillableGuest) =>
        # Update the email form template to remove the loading state and prepare
        # the MBG alert if necessary
        _.extend data,
          isLoading: false
          wouldBecomeBillableGuest: wouldBecomeBillableGuest
          availableLicenseCount: if org? then org.getAvailableLicenseCount() else Infinity
        @$('.js-invite-results').html inviteAddNameTemplate(data)

        # Inject the mbg alert if necessary (lets the user know about any extra billing, or why
        # they are not allowed to invite)
        if wouldBecomeBillableGuest
          Element = React.createElement AutoCompleteMultiBoardGuestAlert, { displayOrg: org, isDesktop }
          if @reactRoot = @$('.js-billable-guests-alert')[0]
            ReactDOM.render(Element, @reactRoot)
      .catch ApiError, (restOrApiError) =>
        error = localizeServerError(restOrApiError)
        _.extend data,
          isLoading: false
          error: error
        @$('.js-invite-results').html inviteAddNameTemplate(data)
      .catch Promise.CancellationError

  _getNewMemberId: (updatedMemberIds, existingMemberIds, newMemberRole, email) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ApiPromise = require 'app/scripts/network/api-promise'
    newMemberId = _.first(_.difference(updatedMemberIds, existingMemberIds))

    if newMemberId?
      track("Invitations", "Send Email Board Invite to New Member", "Role: #{newMemberRole}")
      return Promise.resolve(newMemberId)

    # Someone with this email already belonged to the board, so they couldn't
    # be invited or added. Use server search to find who it is and add them to
    # the card.
    searchParams =
      url: '/1/search/members/'
      type: 'get'
      data:
        onlyOrgMembers: @model.getBoard().getOrganization()?.onlyOrgMembers()
        query: email
      dataType: 'json'
    ApiPromise(searchParams)
    .then (results) =>
      if results.length > 0
        # server-side search by email does an exact search, so this should
        # always return only one result
        results[0].id

  sendEmailInvite: (e) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ApiPromise = require 'app/scripts/network/api-promise'
    Util.stop(e)
    $sendButton = @$('.js-send-email-invite')
    # The email is already being sent
    if $sendButton.attr('disabled')?
      return

    $name = @$('.js-email-data .js-full-name')
    name = $name.val().trim()

    email = @$('.js-email-data .js-email').val().trim()

    if !Util.validName(name)
      Util.setCaretAtEnd($name)
      $('.js-name-error').show()
      return
    else if containsValidUrl(name)
      # Urls are not allowed as member names
      Util.setCaretAtEnd($name)
      $('.js-name-error-url').show()
      return

    data =
      fullName: name
      email: email
      type: 'normal'
      allowBillableGuest: true

    if @$('#addAsObserver').is(':checked')
      data.type = 'observer'

    board = @model.getBoard()

    if maybeDisplayMemberLimitsError($(e.target), board)
      return

    # Disable the button while we're sending the invite
    $sendButton.attr('disabled', 'disabled')

    existingMembers = _.pluck(board.memberList.models, 'id')

    ApiPromise
      url: "/1/board/#{board.id}/members"
      type: 'put'
      data: data
    .then ({ members }) =>
      updatedMemberIds = _.pluck(members, 'id')
      @_getNewMemberId(updatedMemberIds, existingMembers, data.type, email)
    .then (newMemberId) =>
      if newMemberId?
        @model.addMember newMemberId, =>
          @$('.js-send-email-invite').removeAttr('disabled')
          PopOver.hide()

        track("Card", "Change Member", "Add Member")
    .catch ApiError, (resOrApiError) =>
      message = localizeServerError(resOrApiError)

      @$('.js-invite-error').removeClass('hide').find('.error').html(message)
      @$('.js-uninvited-search-results').empty().hide()

      $sendButton.removeAttr('disabled')
      $('js-search-mem').focus().select()

      track("Invitations", "Error", resOrApiError.message ? resOrApiError.responseText)
      return

    return
